<template>
	<ScaleScreen :width="autoW" :height="autoH" class="scale-wrap" :selfAdaption="true" fullScreen>
		<div>
			<div class="bg">
				<dv-loading v-if="loading">Loading...</dv-loading>
				<div v-else class="host-body">
					<div class="d-flex jc-between headerWrapper">
						<div class="d-flex left-aside">
							<!-- <i class="el-icon-sunny tianqi-icon"></i> -->
							<span style="margin-left:50px;margin-right: 30px">{{ weatherData.weather }} {{ weatherData.temperature }}℃</span>
							<span class="text"> {{ dateYear }} {{ dateDay }}</span>
						</div>
						<div class="projectName">{{ projectName }}</div>
						<div class="d-flex aside-width">
							<!-- <div class="rightBox btn-s" v-for="(item, index) in rightTabData" :key="index"
								:class="{ active: item.value === currentTab }" @click="routeChange(item)">
								<i class="icon" :class="item.icon"></i>
								<span class="text fw-b">{{ item.label }}</span>
							</div>
							<div class="back-btn" @click="goBack" v-if="isBack">
								<i class="el-icon-back"></i>
							</div> -->
						</div>
					</div>

					<!-- 第二行 -->

					<layoutMain></layoutMain>
				</div>
			</div>
		</div>
	</ScaleScreen>
</template>

<script>
// import drawMixin from "@/utils/drawMixin";
import axios from 'axios'
import { formatTime } from '@/utils/index.js'
import layoutMain from '@/components/layout/index.vue'
import ScaleScreen from '@/components/scale-screen/scale-screen.vue'
import projectData from '@/utils/data.json'
export default {
	// mixins: [drawMixin],
	data() {
		return {
			timing: null,
			loading: true,
			dateDay: null,
			dateYear: null,
			// autoH:1920/(window.innerWidth/window.innerHeight),
			autoH: 1080,
			autoW: 1920,
			dateWeek: null,
			weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
			decorationColor: ['#568aea', '#000000'],
			rightTabData: [
				// {
				// 	label: '首页',
				// 	value: '/home',
				// 	icon: 'el-icon-s-home'
				// },
				// {
				// 	label: '矿山数据监测',
				// 	value: '/dataMonitor',
				// },
				// {
				// 	label: '应急事件',
				// 	value: '/integratedData',
				// },
			],
			currentTab: '/home',
			menudata: [],
			projectName: '',
			viewData: {},
			isBack: false,
			weatherData: {}
		}
	},
	watch: {
		$route(to, from) {
			// console.log('Route changed from-1111111111111111111', from.path, 'to', to.path);
			if (to.path == '/goodsAndMaterials') {
				this.isBack = true
			} else {
				this.isBack = false
			}
		}
	},
	components: {
		layoutMain,
		ScaleScreen
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.getCurrentIndex(to.path)
		})
	},
	created() {
		this.getMenuData()
	},
	mounted() {
		this.timeFn()
		this.cancelLoading()
		this.autosize()
		window.addEventListener('resize', (e) => {
			this.autosize()
		})
		this.getWeather()
	},
	beforeDestroy() {
		clearInterval(this.timing)
	},

	methods: {
		async getWeather() {
			const key = 'cfe75a6bc6a92dfa020cd10808bb7e7c' // 替换为您的Web服务API密钥
			const adcode = '500110116200'
			const city = '500110'
			try {
				const response = await axios.get(`https://restapi.amap.com/v3/weather/weatherInfo?city=${city}&key=${key}&extensions=base`)
				this.weatherData = response.data.lives[0]
				// console.log('请求天气数', response)
			} catch (error) {
				console.error('请求失败:', error)
				alert('请求天气数据失败，请检查网络连接或API Key')
			}
		},
		autosize() {
			let w = window.innerWidth,
				h = window.innerHeight,
				s = w / h
			if (s < 1920 / 1080) {
				this.autoH = 1920 / s
				this.autoW = 1920
			} else {
				this.autoH = 1080
				this.autoW = 1080 * s
			}
		},
		getMenuData() {
			this.projectName = '乡村民宿产业大脑'
			this.currentTab = `/home`
			this.$router.push({
				path: `/home`
			})
		},
		timeFn() {
			this.timing = setInterval(() => {
				this.dateDay = formatTime(new Date(), 'HH:mm:ss')
				this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
				this.dateWeek = this.weekday[new Date().getDay()]
			}, 1000)
		},
		cancelLoading() {
			setTimeout(() => {
				this.loading = false
			}, 500)
		},
		routeChange(data) {
			if (data.value && data.value != '' && data.value != this.currentTab) {
				// this.projectName = data.label;
				this.currentTab = data.value
				this.$router.push(`${data.value}`)
			}
		},
		getCurrentIndex(path) {
			this.currentTab = path
		},
		goBack() {
			this.$router.go(-1)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';

.scale-wrap {
	width: 100vw;
	height: 100vh;
	font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;

	.bg {
		width: 100%;
		height: 100%;
		/* padding: 16px 16px 0 16px; */
		/* background-image: url('../assets/pageBg.png'); */
		background-size: cover;
		background-position: center center;

		.headerWrapper {
			height: 67px;
			width: 100%;
			background-image: url('../assets/header2.png');
			background-size: 100% 100%;
			margin-top: 10px;
			z-index: 10;

			& > div {
				/* padding-top: 38px; */
			}

			.aside-width {
				flex: 1;
				/* justify-content: space-around; */
				align-items: center;
				padding-left: 30px;
				position: relative;

				.back-btn {
					width: 22px;
					height: 22px;
					border-radius: 50%;
					background-color: #9fd9ff;
					position: absolute;
					right: 35px;
					top: 50%;
					margin-top: -11px;
					display: flex;
					align-items: center;
					justify-content: center;

					.el-icon-back {
						color: #2f4e85;
					}
				}
			}

			.left-aside {
				flex: 1;
				justify-self: start;
				align-items: center;
				color: #cce3ff;
				font-weight: normal;
				font-size: 20px;
				font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;

				.tianqi-icon {
					font-size: 24px;
					color: #7fb8fd;
					margin-right: 20px;
					margin-left: 30px;
				}
			}

			.projectName {
				font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
				/* width: 300px; */
				text-align: center;
				padding-top: 20px;
				margin: 0 90px;
				text-shadow: 5px 5px 5px 5px red;
				font-weight: bold;
				font-size: 36px;
				letter-spacing: 20px;
				color: #ffffff;
			}

			.leftBox,
			.rightBox {
				width: 163px;
				height: 50px;
				font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
				font-weight: normal;
				font-size: 20px;
				color: #79a4ef;
				background-image: url('../assets/home/tab_icon-1.png');
				margin-right: 20px;
				cursor: pointer;

				&.active {
					color: #ffffff;
					background-image: url('../assets/home/tab_icon-2.png');
					background-size: 100% 100%;
					background-position: center center;

					.icon {
						color: #fff;
					}
				}
			}

			.btn-s {
				display: flex;
				align-items: center;
				justify-content: center;

				.icon {
					color: #79a4ef;
					font-size: 24px;
					margin-right: 10px;
				}
			}
		}
	}
}
</style>
